module.exports = __webpack_public_path__ + "fonts/SourceSans3-Bold.17e0687.ttf";